module.exports = __webpack_public_path__ + "media/images/badges/purebarre/PureBarre-500-Classes-Active-e92dfe78e1675e6a544fc8fbceaf57e6.png";